export default __webpack_public_path__ + "partner_4915018.png";